import { defer, Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { finalize, switchMap, startWith, shareReplay, map } from 'rxjs/operators';

function indicate(indicator) {
    return (source) => source.pipe(s => defer(() => {
        indicator.next(true);
        return s;
    }), finalize(() => indicator.next(false)));
}

class PaginationDataSource {
    constructor(endpoint, initialSort, initialQuery, pageSize = 20) {
        this.endpoint = endpoint;
        this.pageSize = pageSize;
        this.pageNumber = new Subject();
        this.loading = new Subject();
        this.loading$ = this.loading.asObservable();
        this.query = new BehaviorSubject(initialQuery);
        this.sort = new BehaviorSubject(initialSort);
        const param$ = combineLatest([this.query, this.sort]);
        this.page$ = param$.pipe(switchMap(([query, sort]) => this.pageNumber.pipe(startWith(0), switchMap(page => this.endpoint({ page, sort, size: this.pageSize }, query)
            .pipe(indicate(this.loading))))), shareReplay(1));
    }
    sortBy(sort) {
        const lastSort = this.sort.getValue();
        const nextSort = Object.assign(Object.assign({}, lastSort), sort);
        this.sort.next(nextSort);
    }
    queryBy(query) {
        const lastQuery = this.query.getValue();
        const nextQuery = Object.assign(Object.assign({}, lastQuery), query);
        this.query.next(nextQuery);
    }
    fetch(page) {
        this.pageNumber.next(page);
    }
    connect() {
        return this.page$.pipe(map(page => page.content));
    }
    disconnect() {
    }
}

/*
 * Public API Surface of ngx-pagination-data-source
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PaginationDataSource };

